import React, { useEffect } from "react";
import { connect } from "react-redux";

import Show from "../../../widgets/Show";

import ChartFillInFormCreatedDate from "../clinical-note/ChartClinicalNoteCreatedDate";
import ReduxCKEditor from "../../../widgets/redux/ReduxCKEditor";
import { Field, useFormik, FormikProvider } from "formik";

const enhancer = connect(({ chartSideFillInForm, session: { permissions } }) => {
  return {
    initialValues: {
      name: chartSideFillInForm.item.name,
      note: chartSideFillInForm.item.content,
      referenceFillInFormId: chartSideFillInForm.fillInFormAddendumId,
    },
    permissions,
  };
});

const ChartFillInFormTextareaForm = (props) => {
  const { onSubmit, initialValues } = props;
  const { edit, item } = props;

  const form = useFormik({
    initialValues,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  useEffect(
    () => () => {
      form.resetForm();
    },
    [],
  );

  return (
    <FormikProvider value={form}>
      <form onSubmit={form.handleSubmit} className="clinical-note-textarea">
        <div className="clinical-note-textarea-name">
          <input
            name="name"
            type="text"
            className="form-control input-lg"
            placeholder="Note Name"
            {...form.getFieldProps("name")}
          />
        </div>
        <div className="clinical-note-textarea-body">
          <Field
            name="note"
            id="clinical-note-textarea-body"
            className="form-control"
            {...form.getFieldProps("note")}
          >
            {() => (
              <ReduxCKEditor
                input={{
                  value: form.values.note,
                  onChange: (value) => form.setFieldValue("note", value),
                }}
              />
            )}
          </Field>
        </div>
        <div className="clinical-note-textarea-footer">
          <Show if={edit}>
            {/*could be updated with permission*/}
            <ChartFillInFormCreatedDate changeCreatedDate={props.changeCreatedDate} item={item} />
          </Show>
          <button type="submit" className="btn btn-primary btn-lg btn-block">
            Save
          </button>
        </div>
      </form>
    </FormikProvider>
  );
};

export default enhancer(ChartFillInFormTextareaForm);
